module.exports = __webpack_public_path__ + "static/spider-rope-b24a9ae14e205033ffcacc0ed1c700aa.png";